module.exports = __webpack_public_path__ + "img/17_98.f799aab5.png";